import { mapState, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import countries from '@/utils/countries';
import states from '@/utils/states';

export default {

	data() {
		return {
			states,
			countries,
			cardSetupComplete: false,
			form: {},
		};
	},

	computed: {

		...mapState({
			isSubscribed: state => state.billing.isSubscribed,
			currentPlan: state => state.billing.currentPlan,
			card: state => state.billing.card,
			upcomingCharge: state => state.billing.upcomingCharge,
			invoices: state => state.billing.invoices,
			subscription: state => state.billing.subscription,
			billingLoading: state => state.billing.loading,
			taxes: state => state.billing.taxRate,
		}),

		...mapGetters([ 'plans', 'usingFreePlan' ]),

		hasPlanLoaded() {
			return typeof this.currentPlan.id !== 'undefined';
		},

		taxRate() {
			return this.taxes.rate;
		},

		cancelling() {
			return this.subscription && !!this.subscription.ends_at;
		},

		planEndsAt() {
			if (this.cancelling) {
				return moment(this.subscription.ends_at).format('MMM D, YYYY');
			}

			return null;
		}

	},

	methods: {

		cardCompleted(token) {
			this.form.token = token;
			this.form.zip = token.card.address_zip;
			this.form.state = token.card.address_state;
			this.form.country = token.card.address_country;
			this.cardSetupComplete = true;

			this.getTaxRate();
		},

		async getTaxRate() {
			if (!this.form.zip) {
				return this.$store.commit('setTaxRate', 0);
			}

			this.$store.dispatch('loadTaxRate', this.form.zip);
		},

		calculatedTax(amount) {
			if (this.taxRate > 0) {
				return ' + $' + parseFloat(amount * this.taxRate).toFixed(2) + ' Sales Tax ';
			}

			return '';
		},

		friendlyFrequency(plan, withSuffix = true) {
			let name = '';
			let suffix = 'ly';
			switch (plan.frequency) {
				case 'MONTHLY':
					name = 'Month';
					break;
				case 'YEARLY':
					name = 'Year';
					break;
			}

			if (withSuffix) name += suffix;

			return name;
		},

		isFreePlan(plan) {
			return plan.stripe_plan_id === null;
		},

	},

};
